<div class="info-item-grid" [class.no-employer-info]="!showEmployerInfo">
  <app-data-label
    *ngFor="let detail of remittanceDetails$ | async"
    [style.min-width.rem]="17"
    [label]="detail.label"
    [value]="detail.value"
    [url]="detail?.url"
    [isLoading]="isLoading" />
</div>
